/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BeMusic
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {DownloadEmailLog200} from './schemas/download-email-log200';

import type {DownloadErrorLogFile200} from './schemas/download-error-log-file200';

import type {DownloadScheduleLog200} from './schemas/download-schedule-log200';

import type {ListErrorLogItemsParams} from './schemas/list-error-log-items-params';

import type {ListErrorLogItems200} from './schemas/list-error-log-items200';

import type {ListOutgoingEmailLogItemsParams} from './schemas/list-outgoing-email-log-items-params';

import type {ListOutgoingEmailLogItems200} from './schemas/list-outgoing-email-log-items200';

import type {ListScheduleLogItemsParams} from './schemas/list-schedule-log-items-params';

import type {ListScheduleLogItems200} from './schemas/list-schedule-log-items200';

import type {RetrieveOutgoingEmailLogItem200} from './schemas/retrieve-outgoing-email-log-item200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List schedule log items
 */
export const listScheduleLogItems = (
  params?: ListScheduleLogItemsParams,
  options?: SecondParameter<typeof orvalApiFetch<ListScheduleLogItems200>>,
) => {
  return orvalApiFetch<ListScheduleLogItems200>(
    {url: `/logs/schedule`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Rerun a schedule log
 */
export const rerunScheduleLog = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/logs/schedule/rerun/${id}`, method: 'POST'},
    options,
  );
};
/**
 * @summary Download the schedule log
 */
export const downloadScheduleLog = (
  options?: SecondParameter<typeof orvalApiFetch<DownloadScheduleLog200>>,
) => {
  return orvalApiFetch<DownloadScheduleLog200>(
    {url: `/logs/schedule/download`, method: 'GET'},
    options,
  );
};
/**
 * @summary Download the email log
 */
export const downloadEmailLog = (
  options?: SecondParameter<typeof orvalApiFetch<DownloadEmailLog200>>,
) => {
  return orvalApiFetch<DownloadEmailLog200>(
    {url: `/logs/outgoing-email/download`, method: 'GET'},
    options,
  );
};
/**
 * @summary Retrieve email log item
 */
export const retrieveOutgoingEmailLogItem = (
  id: number,
  options?: SecondParameter<
    typeof orvalApiFetch<RetrieveOutgoingEmailLogItem200>
  >,
) => {
  return orvalApiFetch<RetrieveOutgoingEmailLogItem200>(
    {url: `/logs/outgoing-email/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary List email log items
 */
export const listOutgoingEmailLogItems = (
  params?: ListOutgoingEmailLogItemsParams,
  options?: SecondParameter<typeof orvalApiFetch<ListOutgoingEmailLogItems200>>,
) => {
  return orvalApiFetch<ListOutgoingEmailLogItems200>(
    {url: `/logs/outgoing-email`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Download an email log item
 */
export const downloadEmailLogItem = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<string | null>>,
) => {
  return orvalApiFetch<string | null>(
    {url: `/logs/outgoing-email/${id}/download`, method: 'GET'},
    options,
  );
};
/**
 * @summary List error log items
 */
export const listErrorLogItems = (
  params?: ListErrorLogItemsParams,
  options?: SecondParameter<typeof orvalApiFetch<ListErrorLogItems200>>,
) => {
  return orvalApiFetch<ListErrorLogItems200>(
    {url: `/logs/error`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Download an error log file
 */
export const downloadErrorLogFile = (
  identifier: string,
  options?: SecondParameter<typeof orvalApiFetch<DownloadErrorLogFile200>>,
) => {
  return orvalApiFetch<DownloadErrorLogFile200>(
    {url: `/logs/error/${identifier}/download`, method: 'GET'},
    options,
  );
};
/**
 * @summary Delete an error log file
 */
export const deleteErrorLogFile = (
  fileIdentifier: string,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/logs/error/${fileIdentifier}`, method: 'DELETE'},
    options,
  );
};
export type ListScheduleLogItemsResult = NonNullable<
  Awaited<ReturnType<typeof listScheduleLogItems>>
>;
export type RerunScheduleLogResult = NonNullable<
  Awaited<ReturnType<typeof rerunScheduleLog>>
>;
export type DownloadScheduleLogResult = NonNullable<
  Awaited<ReturnType<typeof downloadScheduleLog>>
>;
export type DownloadEmailLogResult = NonNullable<
  Awaited<ReturnType<typeof downloadEmailLog>>
>;
export type RetrieveOutgoingEmailLogItemResult = NonNullable<
  Awaited<ReturnType<typeof retrieveOutgoingEmailLogItem>>
>;
export type ListOutgoingEmailLogItemsResult = NonNullable<
  Awaited<ReturnType<typeof listOutgoingEmailLogItems>>
>;
export type DownloadEmailLogItemResult = NonNullable<
  Awaited<ReturnType<typeof downloadEmailLogItem>>
>;
export type ListErrorLogItemsResult = NonNullable<
  Awaited<ReturnType<typeof listErrorLogItems>>
>;
export type DownloadErrorLogFileResult = NonNullable<
  Awaited<ReturnType<typeof downloadErrorLogFile>>
>;
export type DeleteErrorLogFileResult = NonNullable<
  Awaited<ReturnType<typeof deleteErrorLogFile>>
>;
